import { Box, Skeleton, Stack } from '@mui/material';

export function LoadingSkeleton() {
  return (
    <Box px={1.5} py={2}>
      <Stack spacing={1}>
        <Box>
          <Skeleton variant="text" width={125} height={20} />
        </Box>
        <Box>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} variant="text" width="100%" height={60} />
          ))}
        </Box>
      </Stack>
    </Box>
  );
}
